import React, {Component} from 'react';
import './Ozgecmis.css';
import {Card, CardGroup, Col, Container, Row} from "react-bootstrap";
import Duzce from "../img/1519919219790.png";
import Google from "../img/1519952113058.png";
import Pisoco from "../img/1553766057712.png";
import Paradoks from "../img/1581326106278.png";
import Deeplab from "../img/1620173979356.jpg";
import Dks from "../img/pp.jpg";
import {FiChevronsRight} from "react-icons/fi";

class Ozgecmis extends Component {
    render() {
        return (
            <div style={{marginTop:50}}>

                <Container>
                    <Row>
                        <Col sm={6}>
                            <Card className="shadow bg-white ">
                            <Card.Body>
                                <h1 style={{fontFamily: 'Architects Daughter',marginLeft:15,marginTop:10,fontSize:35}}>Deneyim</h1>
                                <div style={{display:"flex"}}>
                                    <div>
                                        <Card className="shadow bg-white " style={{ width:120,height:120,alignItems:"center",marginTop:50}}>
                                            <Card.Text>
                                                <img src={Deeplab} alt="logo" width={120}  height={120}/>
                                            </Card.Text>
                                        </Card>
                                    </div>
                                    <div style={{marginTop:55,marginLeft:50,letterSpacing:2,fontSize:12}}>
                                        <p><b>Bootcamp Student: Frontend Developer</b></p>
                                        <p>DeepLab</p>
                                        <p style={{color:"grey"}}>Aralık 2020 - Mayıs 2021 - 6 ay</p>
                                    </div>
                                </div>
                                <div style={{display:"flex"}}>
                                    <div>
                                        <Card className="shadow bg-white " style={{ width:120,height:120,alignItems:"center",marginTop:50}}>
                                            <Card.Text>
                                                <img src={Pisoco} alt="logo" width={120}  height={120}/>
                                            </Card.Text>
                                        </Card>
                                    </div>
                                    <div style={{marginTop:55,marginLeft:50,letterSpacing:2,fontSize:12}}>
                                        <p><b>Intern</b></p>
                                        <p>pisoco</p>
                                        <p style={{color:"grey"}}>Haziran 2020 - Ekim 2020 - 5 ay</p>
                                    </div>
                                </div>
                                <div style={{display:"flex"}}>
                                    <div>
                                        <Card className="shadow bg-white " style={{ width:120,height:120,alignItems:"center",marginTop:50}}>
                                            <Card.Text>
                                                <img src={Paradoks} alt="logo" width={120}  height={120}/>
                                            </Card.Text>
                                        </Card>
                                    </div>
                                    <div style={{marginTop:55,marginLeft:50,letterSpacing:2,fontSize:12}}>
                                        <p><b>Intern</b></p>
                                        <p>Paradoks</p>
                                        <p style={{color:"grey"}}>Şubat 2020 - Mart 2020 - 2 ay</p>
                                    </div>
                                </div>
                                <div style={{display:"flex"}}>
                                    <div>
                                        <Card className="shadow bg-white " style={{ width:120,height:120,alignItems:"center",marginTop:50}}>
                                            <Card.Text>
                                                <img src={Dks} alt="logo" width={120}  height={120}/>
                                            </Card.Text>
                                        </Card>
                                    </div>
                                    <div style={{marginTop:55,marginLeft:50,letterSpacing:2,fontSize:12}}>
                                            <p><b>Intern</b></p>
                                            <p>Dks Teknoloji</p>
                                            <p style={{color:"grey"}}>Temmuz 2019 - Mart 2020 - 9 ay</p>
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                        </Col>
                        <Col sm={6}>
                            <Card  className="shadow bg-white">
                            <Card.Body> <h1 style={{fontFamily: 'Architects Daughter',marginLeft:15,marginTop:10,fontSize:35}}>Eğitim</h1>
                                <div style={{display:"flex"}}>
                                    <div>
                                        <Card className="shadow bg-white " style={{ width:120,height:120,alignItems:"center",marginTop:50}}>
                                            <Card.Text>
                                                <img src={Duzce} alt="logo" width={120}  height={120}/>
                                            </Card.Text>
                                        </Card>
                                    </div>
                                    <div style={{marginTop:55,marginLeft:50,letterSpacing:2,fontSize:12}}>
                                        <p><b>Düzce Üniversitesi</b></p>
                                        <p>Lisans, Bilgisayar Mühendisliği</p>
                                        <p style={{color:"grey"}}>2017 - 2021</p>
                                    </div>
                                </div></Card.Body>
                        </Card><Card className="shadow bg-white " style={{marginTop:45}}>
                            <Card.Body >  <h1 style={{fontFamily: 'Architects Daughter',marginLeft:15,marginTop:10,fontSize:35}}>Gönüllü deneyimler</h1>
                                <div style={{display:"flex"}}>
                                    <div>
                                        <Card className="shadow bg-white " style={{ width:120,height:120,alignItems:"center",marginTop:50}}>
                                            <Card.Text>
                                                <img src={Google} alt="logo" width={120}  height={120}/>
                                            </Card.Text>
                                        </Card>
                                    </div>
                                    <div style={{marginTop:55,marginLeft:50,letterSpacing:2,fontSize:12}}>
                                        <p><b>Crew Member</b></p>
                                        <p>Google Developers Group</p>
                                        <p style={{color:"grey"}}>Ocak 2020 - Aralık 2020 - 12 ay</p>
                                    </div>
                                </div></Card.Body>
                        </Card></Col>
                    </Row>
                </Container>

            </div>

        );
    }
}

export default Ozgecmis;